const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 32 32"
      enable-background="new 0 0 32 32"
      xmlSpace="preserve"
      width={ 30 }
      fill="none"
      stroke="#ffffff"
      
    >
      <g>
        <g>
          <path
            d="M29.625,1l-3.099,3.172H5.054h-1v1v21.657v1h1h21.472L29.625,31H1V1H29.625 M32,0H0v32h32l-5.054-5.172H5.054V5.172    h21.893L32,0L32,0z"
            strokeWidth={ 1 }
          />
        </g>
        <g>
          <path
            d="M21.038,10.962v10.076H10.962V10.962H21.038 M22.038,9.962H9.962v12.076h12.076V9.962L22.038,9.962z"
            strokeWidth={ 1 }
          />
        </g>
      </g>
    </svg>
  );
};

export default Logo;